import script from "./UpdatePwd.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePwd.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePwd.vue?vue&type=style&index=0&id=4064b7c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4064b7c6"]])

export default __exports__